import { useEffect, useState } from 'react';
import * as sharetribeSdk from 'sharetribe-flex-sdk';

const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

const toBlockType = (id, ImageUrl, title, price, config, description) => {
  const desc = description.length > 100 ? `${description.slice(0, 100)}...` : description;
  const template = {
    media: {
      fieldType: 'image',
      image: {
        id: '6d09bfd2-94e2-5ab0-8f37-91aca829ee91',
        type: 'imageAsset',
        attributes: {
          variants: {
            landscape400: {
              height: 225,
              width: 400,
              url: ImageUrl,
              name: 'landscape400',
            },
            landscape800: {
              height: 450,
              width: 800,
              url: ImageUrl,
              name: 'landscape800',
            },
            landscape1200: {
              height: 675,
              width: 1200,
              url: ImageUrl,
              name: 'landscape1200',
            },
            landscape2400: {
              height: 1350,
              width: 2400,
              url: ImageUrl,
              name: 'landscape2400',
            },
          },
          assetPath:
            '/content/pages/landing-page/block-media-0194c3ce-848a-8edd-ac5d-bc9676702920.jpg',
        },
      },
      aspectRatio: '16/9',
      link: {
        fieldType: 'internalImageLink',
        href: `l/${id}`,
      },
      alt: 'Car',
    },
    title: {
      fieldType: 'heading3',
      content: `${title} • €${price}`,
    },
    text: {
      fieldType: 'markdown',
      content: `${desc}\n***\n**Mileage**: ${config.mileage} km`,
    },
    callToAction: {
      fieldType: 'internalButtonLink',
      content: 'Ver anuncio',
      href: `l/${id}`,
    },
    alignment: 'left',
    blockType: 'defaultBlock',
    blockName: 'Car',
  };
  return template;
};

export const getUserType = userId => {
  return sdk.users
    .show({ id: userId })
    .then(res => {
      const type = res.data.data.attributes.profile.publicData.userType;
      return type;
    })
    .catch(error => {
      console.error('Error fetching user:', error);
      return null;
    });
};

// const sdkUtil = sharetribeSdk.util;
export const getListings = () => {
  return sdk.listings
    .query({
      include: ['images', 'author'],
      sort: 'createdAt',
    })

    .then(response => {
      const data = response.data;

      const res = data.data
        .filter((_, i) => i < 6)
        .map(car => {
          const imageId = car.relationships.images.data[0].id.uuid;
          const imageUrl = data.included.find(image => image.id.uuid === imageId).attributes
            .variants.default.url;
          const publicData = car.attributes.publicData;
          const metadata = car.attributes.metadata;
          const link = `/l/${car.id.uuid}`;
          const title = car.attributes.title;
          const price = car.attributes.price.amount.toString().slice(0, -2);
          const authorId = car.relationships.author.data.id.uuid;

          // return toBlockType(car.id.uuid, imageUrl, title, price, config, description);
          return { link, title, price, publicData, imageUrl, metadata, authorId };
        });

      return res;
    })
    .catch(error => {
      console.error('Error fetching listings:', error);
      return [];
    });
};

export const useListings = () => {
  const [listings, setListings] = useState([]);
  useEffect(() => {
    (async () => {
      const data = await getListings();
      setListings(data);
    })();
  }, []);
  return listings;
};
